import { render, staticRenderFns } from "./shopManageList.vue?vue&type=template&id=da663448&scoped=true"
import script from "./shopManageList.vue?vue&type=script&lang=js"
export * from "./shopManageList.vue?vue&type=script&lang=js"
import style0 from "./shopManageList.vue?vue&type=style&index=0&id=da663448&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da663448",
  null
  
)

export default component.exports